export const MeetLocationType = "integrations:google:meet";

/**
 * Not an actual location app type — a placeholder telling the booking flow to resolve the
 * organizer's default conferencing app. Lives here rather than in `locations.ts` so client
 * bundles can read it without pulling in the whole app-store metadata registry.
 */
export const OrganizerDefaultConferencingAppType = "conferencing";

export const MSTeamsLocationType = "integrations:office365_video";

export const DailyLocationType = "integrations:daily";
